/* eslint-disable */
<template>
  <div class="bookings-awaiting-paperwork">
    <AdminNavigation ref="navigation" indexProps="5" />
    <div class="top-panel">
      <Header />
      <div class="header-title-section">
        <div class="header-title"><h1>Bookings Awaiting Paperwork</h1></div>
        <div class="header-sub-title">The following bookings are awaiting paperwork, listed in due date order.</div>
      </div>
    </div>
    <div class="panel">
      <AdminBookingsMenu :key="bookingMenuIndex" :indexProps="bookingMenuIndex" />
      <div class="content">
        <div class="row">
          <div class="col pt-0 pl-0">Total Bookings Awaiting Paperwork:  {{ total }}</div>
          <div class="col pt-0 d-flex align-items-center flex-column justify-content-start">
            <span>Bookings Awaiting Paperwork, due this week:  {{ numberDue }}</span>
          </div>
        </div>
        <div class="tool-bar row">
          <div class="col">
            <div class="icon-group right-float-element">
              <el-radio-group v-model="radio" @input="filterWeek">
                <el-radio :label="1">Bookings this week</el-radio>
                <el-radio class="mb-0" :label="2">Show ALL bookings that are awaiting paperwork</el-radio>
              </el-radio-group>
              <el-input style="max-width: 200px" class="mr-1" @input="search()" clearable placeholder="Booking ID" v-model="listParam.BookingID"/>
              <el-input style="max-width: 200px" class="mr-1" @input="search()" clearable placeholder="Examinee Name" v-model="listParam.ClaimantName"/>
              <el-input style="max-width: 200px" class="mr-1" @input="search()" clearable placeholder="Client Name" v-model="listParam.ClientName"/>
              <el-input style="max-width: 200px" class="mr-1" @input="search()" clearable placeholder="Contact Name" v-model="listParam.ContactName"/>
            </div>
          </div>
        </div>
        <div class="content-scroll-x">
          <div>
            <div>
              <el-table ref="bookingTable" :default-sort="{prop: 'DueDate', order: 'ascending'}" stripe @sort-change="sortParam" :data="bookings" tooltip-effect="dark" :header-row-style="{background: '#fde9eb', height: '70px'}" :header-cell-style="{fontWeight: 100}">
                <el-table-column
                    width="100"
                    prop="BookingID"
                    label="ID"
                    sortable="custom"
                    show-overflow-tooltip
                    fixed="left"
                >
                </el-table-column>
                <el-table-column
                    width="150"
                    show-overflow-tooltip
                    prop="Client"
                    sortable="custom"
                    label="Client"
                >
                  <template slot-scope="booking">
                    <span>{{booking.row.Case && booking.row.Case.Client && decodeURIComponent(booking.row.Case.Client.ClientName)}} - {{decodeURIComponent(booking.row.Case.Client.BranchName)}}</span>
                  </template>
                </el-table-column>
                <el-table-column
                    width="150"
                    show-overflow-tooltip
                    sortable="custom"
                    prop="ClientContact"
                    label="Contact">
                  <template slot-scope="booking">
                    <span>{{ booking.row.ClientContact && decodeURIComponent(booking.row.ClientContact.FirstName + ' ' + booking.row.ClientContact.MiddleName + ' ' + booking.row.ClientContact.Surname)}}</span>
                  </template>
                  >
                </el-table-column>
                <el-table-column
                    width="150"
                    show-overflow-tooltip
                    prop="Client"
                    label="Phone/Email"
                >
                  <template slot-scope="booking">
                    <span>{{booking.row.ClientContact && booking.row.ClientContact.Mobile + ' / ' + booking.row.ClientContact.EmailAddress}}</span>
                  </template>
                </el-table-column>
                <el-table-column
                    width="150"
                    sortable="custom"
                    show-overflow-tooltip
                    label="Examinee"
                    prop="ClaimantFullName"
                >
                  <template slot-scope="booking">
                    <span>{{ decodeURIComponent(booking.row.Case.ClaimantFullName)}}</span>
                  </template>
                </el-table-column>
                <el-table-column
                    show-overflow-tooltip
                    width="250"
                    prop="BookingType"
                    label="Service Type"
                    sortable="custom"
                >
                  <template slot-scope="booking">
                    <span>{{ decodeURIComponent(booking.row.BookingType.BookingTypeName)}}</span>
                  </template>
                </el-table-column>
                <el-table-column
                    width="140"
                    show-overflow-tooltip
                    prop="DeliveryMethodID"
                    label="Delivery Method"
                >
                  <template slot-scope="scope">
                    <span v-if="scope.row.DeliveryMethodID">{{
                        scope.row.DeliveryMethodID === 1 ? 'In-person' : 'Virtual'
                      }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                    width="190"
                    show-overflow-tooltip
                    prop="DueDate"
                    label="Date Due"
                >
                  <template slot-scope="scope">
                    <span>{{
                        formatDate(scope.row.DueDate, "YYYY-MM-DD", "DD/MM/YYYY")
                      }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                    width="200"
                    prop="custom"
                    label="Paperwork Status"
                    show-overflow-tooltip
                >
                  <template slot-scope="scope">
                    <div class="d-flex align-items-center">
                      <el-tooltip  effect="dark" content="Paperwork Processed" placement="bottom">
                        <img
                            class="ml-4 is-icon"
                            src="@/assets/images/paperwork-processed.svg"
                            :class="isDate(scope.row.PaperworkProcessed) ? '' : 'disabled-element'"
                        />
                      </el-tooltip>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>

        <div v-if="totalCount > listParam.pageSize" class="pagination">
          Page
          <div class="pagination-group">
            <div class="border-icon pagination-current dropdown">
              <div class="pagination-current-text">{{ listParam.pageNum }}</div>
              <div class="pagination-current-icon" data-toggle="dropdown" aria-haspopup="true"
                   aria-expanded="false"></div>
              <div class="dropdown-menu shadow" aria-labelledby="pagination-current-icon">
                <div class="dropdown-item" v-for="item in (1, Math.ceil(totalCount/listParam.pageSize))" :key="item"
                     :class="listParam.pageNum === item ? 'selected' : ''" :value="item" @click="selectPage(item)">
                  {{ item }}
                </div>
              </div>
            </div>
          </div>
          <div class="pagination-total">of &nbsp; {{ Math.ceil(totalCount / listParam.pageSize) }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import utilities from "@/assets/js/utilities"
import AdminNavigation from "@/components/AdminNavigation"
import AdminBookingsMenu from "@/components/AdminBookingsMenu"
import Header from "@/components/Header"
import { debounce } from 'lodash';

export default {
  name: "AdminBookingsAwaitingPaperwork",
  components: {
    AdminNavigation,
    AdminBookingsMenu,
    Header,
  },
  data() {
    return {
      totalCount: 0,
      bookings: [],
      allBookings: [],
      limit: 10,
      pagination: utilities.initPagination(),
      numberDue: 0,
      bookingMenuIndex: 2,
      total: 0,
      byClient: false,
      byContact: false,
      byClaimant: false,
      byTypeOfClaim: false,
      byDate: false,
      byStatus: false,
      listParam: {
        pageSize: 10,
        pageNum: 1,
        orderBy: 11,
        BookingID: null,
        ClientName: '',
        ClaimantName: '',
        ContactName: '',
        ascOrDesc: 'ASC',
        PaperWorkDueFrom: moment().format('yyyy-MM-DD'),
        PaperWorkDueTo: moment().add('days', 7).format('yyyy-MM-DD')
      },
      filterList: [],
      radio: 1,
      paperworkStatuses: [],
    }
  },
  computed: {},
  methods: {
    search: debounce(function () {
      this.selectPage(1)
    }, 800),
    isDate(date) {
      return moment(date).isValid()
    },

    filterWeek(e) {
      if(e === 2) {
        this.listParam = {
          pageSize: 10,
          pageNum: 1,
          orderBy: 11,
          BookingID: null,
          ClientName: '',
          ClaimantName: '',
          ContactName: '',
        }
        this.selectPage(1)
      } else {
        this.listParam = {
          pageSize: 10,
          pageNum: 1,
          orderBy: 11,
          BookingID: null,
          ClientName: '',
          ClaimantName: '',
          ContactName: '',
          PaperWorkDueFrom: moment().format('yyyy-MM-DD'),
          PaperWorkDueTo: moment().add('days', 7).format('yyyy-MM-DD')
        }
        this.selectPage(1)
      }
    },
    selectPage(index) {
      this.listParam.pageNum = index
      this.loadBookings()
    },
    customSort(sort) {
      this.listParam.orderBy = sort.target.id
      this.listParam.ascOrDesc = 'DESC'
      this.selectPage(1)
    },
    sortParam( v ) {
      this.listParam.orderBy = v.prop
      if(v.order === "ascending") {
        this.listParam.ascOrDesc = 'ASC'
      } else if (v.order === "descending") {
        this.listParam.ascOrDesc = 'DESC'
      } else {
        this.listParam.orderBy = null
        this.listParam.ascOrDesc = null
      }

      this.selectPage(1)
    },
    formatDate(dateToFormat, newFormat, currentFormat = "") {
      return utilities.formatDate(dateToFormat, newFormat)
    },

    async loadBookings() {
      this.$store.dispatch("loading/setLoadComponent", true)
      let obj = {...this.listParam}
      for (let key in obj) {
        if (obj[key] === null || obj[key] === '') {
          delete obj[key];
        }
      }
      const {bookings, total }= await utilities.getBookingAwaitingPaperworkNew(obj)
      this.bookings = _.cloneDeep(bookings)
      this.totalCount = total
      this.$store.dispatch("loading/setLoadComponent", false)
    },

  },
  async beforeMount() {
    await this.loadBookings()
    this.numberDue = this.totalCount
    const {bookings, total}= await utilities.getBookingAwaitingPaperworkNew({pageNum:1, pageSize:10})
    this.total = total
    this.filterList = bookings
  },
  mounted() {
    $(".pagination").hide()
  },
}
</script>
